export const userPanelDateTimeFormat: string = 'MMM dd, yyyy, hh:mm a';
